import { FC } from 'react';

type Props = {
	className?: string;
};

const FaqIconSolid: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='#2B2B2B'
			stroke='none'
			className={className}>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M1.04297 10.0003C1.04297 5.05278 5.05375 1.04199 10.0013 1.04199C14.9489 1.04199 18.9596 5.05278 18.9596 10.0003C18.9596 14.9479 14.9489 18.9587 10.0013 18.9587C5.05375 18.9587 1.04297 14.9479 1.04297 10.0003ZM9.16797 13.7503C9.16797 13.2901 9.54105 12.917 10.0013 12.917H10.0088C10.4691 12.917 10.8421 13.2901 10.8421 13.7503C10.8421 14.2106 10.4691 14.5837 10.0088 14.5837H10.0013C9.54105 14.5837 9.16797 14.2106 9.16797 13.7503ZM9.16797 7.91699C9.16797 7.45676 9.54105 7.08366 10.0013 7.08366C10.4616 7.08366 10.8346 7.45676 10.8346 7.91699C10.8346 8.08413 10.7863 8.23744 10.7031 8.36674C10.6047 8.51966 10.4796 8.68091 10.3254 8.87249L10.2507 8.96499C10.1214 9.12483 9.97522 9.30574 9.84197 9.48882C9.52864 9.91949 9.16797 10.5157 9.16797 11.2503C9.16797 11.7106 9.54105 12.0837 10.0013 12.0837C10.4616 12.0837 10.8346 11.7106 10.8346 11.2503C10.8346 11.0645 10.9262 10.8314 11.1896 10.4694C11.2956 10.3237 11.41 10.1822 11.5387 10.0228L11.6239 9.91733C11.7794 9.72399 11.9541 9.50266 12.1047 9.26857C12.3557 8.87841 12.5013 8.41341 12.5013 7.91699C12.5013 6.53628 11.3821 5.41699 10.0013 5.41699C8.62055 5.41699 7.5013 6.53628 7.5013 7.91699C7.5013 8.37724 7.87439 8.75033 8.33464 8.75033C8.79489 8.75033 9.16797 8.37724 9.16797 7.91699Z'
				fill='inherit'
				stroke='transparent'
			/>
		</svg>
	);
};

export default FaqIconSolid;
